export default  {
    apiKey: "AIzaSyAemRGpTKzdnsFq3oJKG4m22JrK73j6Wc0",
    authDomain: "hiragana-df219.firebaseapp.com",
    projectId: "hiragana-df219",
    storageBucket: "hiragana-df219.appspot.com",
    messagingSenderId: "606607891564",
    appId: "1:606607891564:web:6bef6ce15fa95e4f3c0c49",
    measurementId: "G-X4QX2C0FL6"
}